import buildMeta from '@/router/utils/buildMeta'
import {
  hasScanParameters,
  userCanAccessNetworkingMessageGenerator,
} from '../guards/linkedinScan'

const routes = [
  {
    name: 'linkedin-scan',
    path: '/linkedin-scan',
    component: () => import('@/pages/LinkedinScan/LinkedinScan.vue'),
    meta: buildMeta({
      authRequired: true,
      robots: 'noindex',
      pageTitle: 'Linkedin Scan',
      title: 'Linkedin Scan - Jobscan',
    }),
  },
  {
    name: 'linkedin-scan-report',
    path: '/linkedin-scan/report',
    component: () => import('@/pages/LinkedinScan/LinkedinScanReport.vue'),
    beforeEnter: [hasScanParameters],
    meta: buildMeta({
      authRequired: true,
      robots: 'noindex',
      pageTitle: 'Linkedin Scan',
      title: 'Linkedin Scan - Jobscan',
    }),
  },
  {
    name: 'linkedin-scan-history',
    path: '/linkedin-scan-history',
    component: () => import('@/pages/LinkedinScan/LinkedinScanHistory.vue'),
    meta: buildMeta({
      authRequired: true,
      robots: 'noindex',
      pageTitle: 'Linkedin Scan History',
      title: 'Linkedin Scan History - Jobscan',
    }),
  },
  {
    name: 'networking-message-generator',
    path: '/networking-message-generator',
    component: () =>
      import('@/pages/LinkedinScan/NetworkingMessageGenerator.vue'),
    beforeEnter: [userCanAccessNetworkingMessageGenerator],
    meta: buildMeta({
      authRequired: true,
      robots: 'noindex',
      pageTitle: 'Networking Message Generator',
      title: 'Networking Message Generator - Jobscan',
    }),
  },
]

export default routes
